import Booking1 from "./Booking1";

const bookings = {
    1: Booking1
};

export default bookings;